import { monroeConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function MonroePage() {
  return <CityPageTemplate config={monroeConfig} />;
}